import axiosInstance from "../axiosInstance";

const Get = async (path) => {
  const result = await axiosInstance.get(path);
  return result.data;
};

export default Get;
